<template>
  <div class="can-pedalsure hp-block-container">
    <h2 class="hp-block-title">Peace-of-mind on the trails</h2>
    <div class="element-container hp-cards">
      <div>
        <b>Outstanding value</b>: We believe we can’t be beaten on price, cover
        and service
      </div>
      <div>
        <b>Excellent rating</b>: Rated Excellent by cyclists across the country
      </div>
      <div>
        <b>Super-fast service</b>: We aim to cover and pay out faster than
        anyone else
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.can-pedalsure {
  // border-top: 1px solid $ps-border;
}

.title {
  text-align: center;
  font-family: $family-regular;
  margin: 20px 0 0 0;
  font-size: 1.6rem;
  @include tablet {
    margin: 50px 0;
    font-size: 2.5rem;
  }
}
.subtitle {
  color: $ps-gray;
  line-height: 2rem;
}
</style>
